import { IsNotEmpty, IsUUID } from 'class-validator';

export class DownloadPolicyVersionDto {
  @IsUUID()
  @IsNotEmpty()
  id: string;

  @IsUUID()
  @IsNotEmpty()
  versionId: string;
}
